import {
    BANNER_HEIGHT_DESKTOP_FULL_SCREEN,
    FULL_COLUMN_WIDTH_FULL_SCREEN,
} from '~/modules/page-builder/config/column-constants';
import { getBannerDimensions } from '~/utils/banner-utils';
import { BANNER_PARALLAX_SCALE } from './banner-motion';

/**
 * The shape banners are cropped to: the legacy full-width banner frame, which
 * every banner is still authored in.
 */
const BANNER_ASPECT =
    FULL_COLUMN_WIDTH_FULL_SCREEN / BANNER_HEIGHT_DESKTOP_FULL_SCREEN;

/**
 * The size Boost Resolution should bring a revamp hero's banner up to.
 *
 * Not the hero's box. The hero crops the banner to cover a box taller than the
 * banner's own frame and scales it for the parallax, so the banner is drawn at
 * the width that fills the box's *height*. The upscalers size their output by
 * width alone, so asking for the box's width left the result half again too
 * small, and the boosted banner still drew soft.
 */
export const getRevampHeroUpscaleTarget = (): {
    width: number;
    height: number;
} => {
    const box = getBannerDimensions('project', { projectRevamp: true });
    const width = Math.ceil(
        Math.max(box.width, box.height * BANNER_ASPECT) * BANNER_PARALLAX_SCALE,
    );
    return { width, height: Math.ceil(width / BANNER_ASPECT) };
};
